

$(document).ready(function(){
  
    // add to Favorites list  
    $('#prod-detail-col #add-fav, .grid-item form a.btn-wish').click(function(e){
	   e.preventDefault();
       $(this).css({ "color": "#eaeaea", "text-decoration": "none" });
	   var f = $(this).parent();
       var f_data = f.serialize();
  	   var f_url = f.attr("action");
       addItem(f_data,f_url);
    });
  	
  	// add all items to Favorites list  
    $('#profile-match a#add-all, #buttons a#add-all-test').click(function(e){
	   e.preventDefault();
       var thisID = $(this).attr('id');
       var fav_list = $('#fav-list').val();
       var prod_num = 0;
       if (thisID=='add-all') { // PROFILE PAGE
       		$(this).css({ "color": "#eaeaea", "text-decoration": "none" });
      		$('#profile-wrapper a.btn-wish').each(function(){
       			fav_list += '_' + $(this).attr('id');
      	 		prod_num++;
       		});
         	// All products already in cart
         	if (prod_num==0) {
         		favAlready();
         		$(this).css("color", "#777676");
       		} else { // Make Ajax call
         		if (prod_num>1) {
        			$('#cart-add-div h3 span').text('These items have');
         		}
         		$('#fav-list').val(fav_list);
         		var f = $('#frm-add-all');
         		var f_data = f.serialize();
         		var f_url = f.attr("action");  
         		addItem(f_data,f_url);
       		}
       } else if (thisID=='add-all-test') { // SKIN TEST RESULTS PAGE
         	$('#test-result-prods a.btn-wish-test').each(function(){
       			fav_list += '_' + $(this).attr('id');
      	 		prod_num++;
              	var theParent = $(this).parent();
         		var pTxt = '<p class="fav-already">Added</p>';
         		theParent.append(pTxt);
              	$(this).remove();
       		});
         	// All products already in cart
         	if (prod_num==0) {
         		$('#alert').text("All products are already in your Favorites List").show().delay(3000).fadeOut();
       		} else { // Make Ajax call
         		$('#fav-list').val(fav_list);
         		var f = $('#frm-add-all');
         		var f_data = f.serialize();
         		var f_url = f.attr("action");
              	var a_txt = "All products were added your Favorites List";
              	var the_a = "";	
              	var the_p = "";
         		addItemTest(f_data,f_url,a_txt,the_p,the_a);
       		}
         
       }
    });
  
    // close modal
    $('#fb-close-add').click(function(e){
	   e.preventDefault();
       location.reload();
	   //$.fancybox.close();
    });
  
  	// close unapproved modal
    $('#fb-close-na').click(function(e){
	   e.preventDefault();
       $.fancybox.close();
    });
  
    // remove item from Favorites list  
    $('#fav-list-wrapper a.btn-remove').click(function(e){
      var fav_string = '';
      e.preventDefault();
      $(this).attr('href', '').css({ "color": "#eaeaea", "text-decoration": "none" });
      $('#fav-list-wrapper a.btn-remove').each(function(){
        var handle = $(this).attr('href');
        if (handle != '') {
          fav_string += handle + '_';
        }
      });
      fav_string = fav_string.slice(0,-1);
      $('input#fav-new').val(fav_string);
      removeItem();
    });
  	
  	// remove all items
  	$('a#remove-all').click(function(e){
      	e.preventDefault();
        $(this).css({ "color": "#eaeaea", "text-decoration": "none" });
    	$('input#fav-new').val('');
  		removeItem();
    });
  	
  	// Unapproved Stockist tries to add Item to Favorites
  	$('#prod-detail-col #add-fav-na, .grid-item form a.btn-wish-na').click(function(e){
    	e.preventDefault();
      	unApproved();
    });
  
});

function addItem(form_data, form_url) {
    // metafields Update for Favorites
    $.ajax({
      	type: "POST",
        dataType: "json",
      	data: form_data,
        url: form_url, 
        cache: false,
        beforeSend: loaderBox,
      	success: FavAddSuccess,
        error: FavAddError
    });
}

function addItemTest(form_data, form_url, test_txt, the_parent, the_link) {
    // metafields Update for Favorites
    $.ajax({
      	type: "POST",
        dataType: "json",
      	data: form_data,
        url: form_url, 
        cache: false,
      	success: function(data){
          	$('#alert').text(test_txt).show().delay(3000).fadeOut();
          	//var pTxt = '<p class="fav-already">Added</p>';
          
          	var para = document.createElement("p");
			var node = document.createTextNode("Added");
          	para.appendChild(node);
          	para.classList.add("fav-already");
          
          	if (the_parent!="") {
          		the_parent.appendChild(para);
       			the_link.remove();	
            }
        },
        error: FavAddError
    });
}

function removeItem() {
    // metafield Update masked as Removal
	var f = $('#fav-remove');
    var f_data = f.serialize();
  	var f_url = f.attr("action");
  	console.log(f_data);
  	$.ajax({
      	type: "POST",
        dataType: "json",
      	data: f_data,
        url: f_url, 
        cache: false,
      	beforeSend: loaderBox,
      	success: FavRemoveSuccess,
        error: FavRemoveError
    });
}

function FavAddSuccess() {
    $.fancybox({
	   'autoScale': true,
	   'transitionIn': 'elastic',
	   'transitionOut': 'elastic',
	   'speedIn': 500,
	   'speedOut': 300,
	   'autoDimensions': true,
	   'centerOnScroll': true,
       'afterClose': function() {
    	   location.reload();
       },
	   'href' : '#cart-add-div'
    });
}

function FavAddError() {
    alert('There was an errot with your request.');
}

function FavRemoveSuccess() {
	location.reload();   
}

function FavRemoveError() {
    alert('There was an errot with your request.');
}

function loaderBox() {
	$('body').prepend('<div id="loader-box">Loading...</div>');
}

function favAlready() {
    $.fancybox({
	   'autoScale': true,
	   'transitionIn': 'elastic',
	   'transitionOut': 'elastic',
	   'speedIn': 500,
	   'speedOut': 300,
	   'autoDimensions': true,
	   'centerOnScroll': true,
	   'href' : '#cart-already-div'
    });
}

function unApproved() {
    $.fancybox({
	   'autoScale': true,
	   'transitionIn': 'elastic',
	   'transitionOut': 'elastic',
	   'speedIn': 500,
	   'speedOut': 300,
	   'autoDimensions': true,
	   'centerOnScroll': true,
	   'href' : '#unapproved-div'
    });
}